import { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';
import DataTable from '../components/DataTable';
import { fetchReferrals } from '../api/placeholder';

const columns = [
  { key: 'referring_user_phone', label: 'Referrer Phone' },
  { key: 'referring_user_name', label: 'Referrer Name' },
  { key: 'referral_name', label: 'Referral Name' },
  { key: 'referral_phone', label: 'Referral Phone' },
  { key: 'referral_date', label: 'Date' },
  {
    key: 'message_sent',
    label: 'Message Sent',
    render: (val) =>
      val ? (
        <span className="inline-flex items-center gap-1 rounded-full bg-neon-green/15 px-2.5 py-0.5 text-xs font-semibold text-neon-green border border-neon-green/30">
          Sent
        </span>
      ) : (
        <span className="inline-flex items-center gap-1 rounded-full bg-neon-amber/15 px-2.5 py-0.5 text-xs font-semibold text-neon-amber border border-neon-amber/30">
          Pending
        </span>
      ),
  },
];

export default function Referrals() {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchReferrals()
      .then(setReferrals)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex h-[calc(100vh-8rem)] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-neon-cyan border-t-transparent" />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-slate-100">Referrals</h1>
          <p className="text-sm text-slate-500">Track user referrals and message delivery status</p>
        </div>
        <div className="rounded-2xl border border-surface-600 bg-surface-800 p-8 text-center">
          <p className="text-sm text-neon-pink">{error}</p>
          <p className="mt-2 text-xs text-slate-500">Make sure the n8n workflow is active and listening.</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6 flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-100">Referrals</h1>
          <p className="text-sm text-slate-500">
            Track user referrals and message delivery status
          </p>
        </div>
        <a
          href="https://docs.google.com/spreadsheets/d/1xsc93aBjyyq_zsw9SkQpJo1dRhASxQrRIfzvItQlpQg/edit?gid=1260125427#gid=1260125427"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 rounded-xl border border-neon-cyan/30 bg-neon-cyan/10 px-4 py-2 text-sm font-medium text-neon-cyan transition-all hover:bg-neon-cyan/20 hover:shadow-neon-cyan"
        >
          <ExternalLink size={16} />
          Export
        </a>
      </div>

      <DataTable columns={columns} data={referrals} emptyMessage="No referrals found" />
    </div>
  );
}
